import { useEffect, useRef, useState } from 'react';
import ContentLoader from 'react-content-loader';

const MIN_WIDTH = 400;
const HEIGHT = 60;

const ListItemSkeleton = ({ height = HEIGHT, ...props }) => {
	const wrapRef = useRef();
	const [w, setW] = useState(MIN_WIDTH);

	useEffect(() => {
		if (!wrapRef.current) return;
		const ro = new ResizeObserver(entries => {
			for (const entry of entries) {
				setW(Math.max(MIN_WIDTH, Math.floor(entry.contentRect.width)));
			}
		});
		ro.observe(wrapRef.current);
		return () => ro.disconnect();
	}, []);

	return (
		<div ref={wrapRef} style={{ width: '100%' }}>
			<ContentLoader
				speed={2}
				width='100%'
				height={height}
				viewBox={`0 0 ${w} ${height}`}
				backgroundColor='#f3f3f3'
				foregroundColor='#ecebeb'
				preserveAspectRatio='xMinYMin meet'
				{...props}
			>
				<rect
					x='15'
					y={height / 2 - 20}
					width='50'
					height='50'
					rx='12'
					ry='12'
				/>

				<rect x='80' y='10' rx='6' ry='6' width='100' height='16' />
				<rect x='80' y='35' rx='6' ry='6' width='80' height='8' />

				<rect x={w - 100 - 20} y='10' rx='6' ry='6' width='100' height='16' />
				<rect x={w - 80 - 20} y='35' rx='6' ry='6' width='80' height='8' />
			</ContentLoader>
		</div>
	);
};
export default ListItemSkeleton;
